export default __webpack_public_path__ + "static/media/albufissapic2.f48dc1ca.jpg";